import { StringOption } from "@/types/common-types";

export const SELECT_RAW_STATUS = ["blacklisted", "bad", "usual", "good", "unknown"] as const;

export type SelectRawStatus = (typeof SELECT_RAW_STATUS)[number];

export const SELECT_RAW_TYPE = [
  "table_profile",
  "bs_stats",
  "room_stats",
  "teamplay",
  "toxic",
  "verdict",
  "max_bots",
] as const;

export type SelectRawType = (typeof SELECT_RAW_TYPE)[number];

export const selectRawStatusOptions: StringOption[] = SELECT_RAW_STATUS.map((value) => ({
  value,
  label: value,
}));

export const selectRawTypeOptions: StringOption[] = SELECT_RAW_TYPE.map((value) => ({
  value,
  label: value,
}));

export type SelectRawData = {
  type?: SelectRawType;
  status?: SelectRawStatus;
  room?: string;
  technology?: string;
  game_type?: string;
  game_group?: string;
  seats?: number;
  weight?: number;
  rakeback?: number;
  limit?: number[];
  script?: string;
};

export type SelectRawOptionalField =
  | "status"
  | "room"
  | "technology"
  | "game_type"
  | "game_group"
  | "seats"
  | "rakeback"
  | "limit";

/** Fields shown in the form for each type (weight + script are always shown). */
export const SELECT_RAW_VISIBLE_FIELDS: Record<SelectRawType, SelectRawOptionalField[]> = {
  bs_stats: [],
  max_bots: ["room"],
  room_stats: [],
  teamplay: [],
  toxic: [],
  verdict: ["status"],
  table_profile: ["room", "technology", "game_type", "game_group", "rakeback", "limit"],
};
